import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { installAuthGuard } from './router/guards'
const app = createApp(App)

app.use(createPinia())
// The guard reads the auth store, so it goes in after Pinia, and before the router starts.
installAuthGuard(router)
app.use(router)
app.mount('#app')
